import { userService } from '../../services/user.service'
import { Redirect } from 'react-router-dom'

function ServiceSelectionRequired(props) {
    const managedService = userService.getManagedService()
    if (managedService == null) return <Redirect to='/' />

    return props.children
}

export default ServiceSelectionRequired
